
        var result = require("!!../../../../node_modules/css-loader/index.js!./article-salesgroup.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-base/article-salesgroup.component.css
// module id = 2397
// module chunks = 1